<template>
  <div id="nav" class="hide-mobile hide-tablet">
    <router-link class="router-link text-link" to="/">HOME</router-link>
    <router-link class="router-link text-link" to="/about">ABOUT</router-link>
    <router-link class="router-link" to="/"
      ><img alt="EVAPAPA" src="../assets/logo800.gif"
    /></router-link>
    <router-link class="router-link text-link" to="/contact"
      >CONTACT</router-link
    >
    <router-link class="router-link text-link" to="/portfolio"
      >PORTFOLIO</router-link
    >
  </div>
</template>

<script>
export default {
  name: "Nav"
};
</script>
